import { render, staticRenderFns } from "./company-offwarning.vue?vue&type=template&id=56395e1d&scoped=true&"
import script from "./company-offwarning.vue?vue&type=script&lang=ts&"
export * from "./company-offwarning.vue?vue&type=script&lang=ts&"
import style0 from "./company-offwarning.vue?vue&type=style&index=0&id=56395e1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56395e1d",
  null
  
)

export default component.exports